import axios from "axios";
import React, { useEffect, useState } from "react";
import { Loader } from "../Loader/Loader";

const Test = (props) => {
  const [following, setFollowing] = useState(props.isFollowing);
  const [text, setText] = useState(following ? "Unfollow" : "+ Follow");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setText(following ? "Following" : "+ Follow");
  }, [setText, following]);

  const handleOnClick = () => {
    const action = following ? "unfollow" : "follow";

    setLoading(true);
    axios
      .post(`/channel/${props.channel.slug}/${action}`)
      .then(() => {
        setFollowing(!following);
      })
      .finally(() => setLoading(false));
  };

  const handleOnMouseOver = () => {
    if (following) setText("Unfollow");
  };

  const handleOnMouseLeave = () => {
    if (following) setText("Following");
  };

  // const className =
  //   props.outline === "true"
  //     ? ""
  //     : "btn-outline-dark bg-dark-blue bg-hover-tertiary text-white hover-primary m-0 btn-primary-outline btn-hover-tertiary-outline";

  return (
    <button
      type="submit"
      // class={`btn btn-sm ${className}`}
      class={`btn btn-sm`}
      onMouseOver={handleOnMouseOver}
      onMouseLeave={handleOnMouseLeave}
      onClick={handleOnClick}
    >
      {loading ? <Loader /> : text}
    </button>
  );
};

export default Test;
